import { Badge } from "../../../core/components/ui/badge";

type Variant = "success" | "warning" | "danger";

/** Seuils de marge (cahier §5.8) : ≥ 40 % confortable, 20–40 % à surveiller, < 20 % insuffisante. */
export function marginVariant(pct: number): Variant {
  if (pct >= 40) return "success";
  if (pct >= 20) return "warning";
  return "danger";
}

export function formatPct(pct: number): string {
  return `${new Intl.NumberFormat("fr-CA", { maximumFractionDigits: 1 }).format(pct)} %`;
}

/** Marge d'un service en badge coloré ; « Sur devis » quand elle n'est pas calculable. */
export function MarginBadge({ pct }: { pct: number | null | undefined }) {
  if (pct === null || pct === undefined) return <Badge variant="neutral">Non calculée</Badge>;
  return <Badge variant={marginVariant(pct)}>{formatPct(pct)}</Badge>;
}
